import { isMobile } from 'hooks';
import { Flex } from 'components/flex';
import { CloseButton } from 'components/specified-buttons';

import { DrawerHeaderProps } from './types';

export const DrawerHeader = ({
  title,
  buttons,
  onClose,
  rightSlot,
  ...flexProps
}: DrawerHeaderProps) => {
  const mobile = isMobile();

  return (
    <Flex alignItems="center" justifyContent="space-between" {...flexProps}>
      <Flex alignItems="center" gap={mobile ? 16 : 40}>
        <h2>{title}</h2>

        {buttons && <Flex gap={16}>{buttons}</Flex>}
      </Flex>

      <Flex gap={24}>
        {rightSlot}
        {onClose && <CloseButton onClose={onClose} />}
      </Flex>
    </Flex>
  );
};
